var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stat-card" }, [
    _c("div", { staticClass: "title" }, [
      _vm.icon
        ? _c(
            "div",
            { staticClass: "icon" },
            [_c("md-icon", [_vm._v(_vm._s(_vm.icon))])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "value-wrapper" }, [
      _c("span", { staticClass: "value" }, [_vm._v(_vm._s(_vm.value))]),
      _vm._v(" "),
      _vm.unit
        ? _c("div", { staticClass: "unit" }, [
            _c("span", [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.unit))]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "description" }, [
      _vm._v("\n        " + _vm._s(_vm.description) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }